import { z } from 'zod';
import { accountReferenceSchema } from './account';
import { accountBalancesSchema } from './account_balance';
import { accountGroupSchema } from './account_group';
import { objectMapSchema } from './object_map';

const financialOverviewSchema = <TPeriodSchema extends z.ZodType>(periodSchema: TPeriodSchema) =>
  z.object({
    periods: periodSchema.array(),
    accountBalances: objectMapSchema(accountReferenceSchema, accountBalancesSchema(periodSchema)),
    groupBalances: objectMapSchema(accountGroupSchema, accountBalancesSchema(periodSchema)),
  });

export { financialOverviewSchema };
